import { useNotification } from 'hooks/ui/useNotification';
import { useMutation } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { saveAs } from 'file-saver';
import { format } from 'date-fns';

type SelectedInvestor = {
  _id: string;
  fullName: string;
};

export function useInvestorReportingPdfBulkDownload(
  reportingId: string,
  reportName: string,
  selectedInvestors: Array<SelectedInvestor>,
) {
  const notification = useNotification();

  const date = format(new Date(), 'dd-MM-yyyy');
  const filename = `${reportName} Reports - ${date}`;

  async function requestBulkInvestorReportingPdfData() {
    const response = await api.post(
      `investor-reporting/bulk-export-pdf-by-report/${reportingId}`,
      {
        selectedInvestors,
        reportName,
      },
      { responseType: 'blob' },
    );

    if (response.status !== 200) {
      throw new Error('Failed to fetch PDF zip data');
    }

    saveAs(response.data, filename);
  }

  return useMutation({
    mutationFn: requestBulkInvestorReportingPdfData,
    onError: () => {
      notification.error('Unable to download PDFs.');
    },
  });
}
